/** A retired auth client must never persist late refresh results or delete a replacement session. */
export function createRetirableAuthStorage(storage: Storage) {
  let retired = false;
  return {
    getItem(key: string): string | null {
      return retired ? null : storage.getItem(key);
    },
    setItem(key: string, value: string): void {
      if (!retired) storage.setItem(key, value);
    },
    removeItem(key: string): void {
      if (!retired) storage.removeItem(key);
    },
    // One-way: only a new document/client may establish another lifecycle.
    retire(): void {
      retired = true;
    },
  };
}
